var _path, _path2, _g, _path3, _g2, _g3, _g4, _circle, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7737 43.3001C130.55 47.7784 117.015 17.9998 150.183 18C183.351 18.0002 184.24 74.6485 166.571 100.026C153.341 119.026 129.933 134.607 86.3765 132.867C11.6206 129.882 6.92211 40.7503 51.7737 43.3001Z",
    fill: "#F3EBDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4798 71.7974H80.1135L84.2037 78.6142H62.3896L66.4798 71.7974Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_2169)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.109,
    cy: 45.4454,
    rx: 28.3326,
    ry: 28.3712,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.109 11.1016C89.5811 11.1016 102.933 23.8887 102.933 39.6643C102.933 43.8578 102.534 47.7658 100.837 51.3464C99.0107 48.6678 96.2174 46.4951 93.6363 44.6841C93.6147 44.6703 93.6003 44.6566 93.5859 44.6428C90.2498 42.4324 88.0569 38.7485 88.0569 34.5687V32.1173C88.0569 35.3193 86.7627 38.2251 84.6632 40.408C82.3265 42.8318 78.9976 44.3536 75.2875 44.3536L52.4379 44.6359C49.9574 45.0422 47.2744 48.4544 45.3475 51.3464C43.6435 47.7727 43.2852 43.8509 43.2852 39.6643C43.2852 23.8887 56.6369 11.1016 73.109 11.1016Z",
    fill: "#E6D3BA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2037 78.6138H62.3896V110.653H84.2037V78.6138Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.301 81.3699L69.3016 85.1942L71.3407 88.4778L68.4071 107.718L62.3294 78.6533C58.4617 80.7237 54.752 83.0974 51.2527 85.748C48.0823 88.1876 45.5433 91.3525 43.8463 94.979L39.3998 104.553L34.4666 115.103C33.5852 116.988 33.7299 119.191 34.8481 120.944L46.2537 138.193H92.5864L93.9019 108.338L102.769 120.206C104.202 122.105 106.491 123.16 108.859 123.028L137.314 120.826C139.235 120.707 140.695 119.046 140.577 117.12C140.471 115.353 139.064 113.955 137.314 113.85L111.556 111.766L102.348 94.0823C101.295 92.0515 99.9665 90.1789 98.401 88.5173C97.5064 87.5678 96.5461 86.6843 95.52 85.8799C91.9549 83.1633 88.1662 80.7369 84.2197 78.6138L78.1156 107.718L75.1162 88.4382L77.1553 85.1546L74.1691 81.3171L72.301 81.3699ZM46.793 119.257C46.3984 118.597 46.3984 117.78 46.793 117.12L53.5811 107.019L54.9888 132.905L46.793 119.257Z",
    fill: "#CFAE80"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1275_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.955 49.9478L138.782 40.5972C138.217 40.3869 137.605 40.3869 137.04 40.5972L113.09 49.9478C112.195 50.2984 111.606 51.1633 111.606 52.1218V80.1734C111.606 95.6017 135.603 105.303 136.639 105.724C137.204 105.934 137.817 105.934 138.382 105.724C139.418 105.303 163.415 95.6017 163.415 80.1734V52.1218C163.415 51.1633 162.85 50.3218 161.955 49.9478Z",
    fill: "#E6D3BA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1275_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.236 56.7185L138.381 50.0952C137.994 49.9461 137.575 49.9461 137.189 50.0952L120.802 56.7185C120.19 56.9668 119.787 57.5795 119.787 58.2584V78.1282C119.787 89.0567 136.206 95.9283 136.915 96.2264C137.302 96.3754 137.72 96.3754 138.107 96.2264C138.816 95.9283 155.235 89.0567 155.235 78.1282V58.2584C155.235 57.5795 154.848 56.9834 154.236 56.7185Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.964,
    cy: 84.0703,
    r: 9.54636,
    fill: "#CFAE80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.192 84.0707L155.579 87.0539L162.142 82.2808",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_2169",
    x: 43.2852,
    y: 11.1016,
    width: 59.6475,
    height: 62.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.756863 0 0 0 0 0.615686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_2169"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_2169",
    x: 33.8945,
    y: 78.6138,
    width: 106.688,
    height: 63.5796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.756863 0 0 0 0 0.615686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_2169"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1275_2169",
    x: 111.606,
    y: 40.4395,
    width: 51.8086,
    height: 65.4419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.756863 0 0 0 0 0.615686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_2169"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1275_2169",
    x: 117.787,
    y: 47.9834,
    width: 39.4482,
    height: 50.355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.843137 0 0 0 0 0.741176 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1275_2169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1275_2169",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.a4d5b829240dd5ac0c629a21c39ef40e.svg";
export { ForwardRef as ReactComponent };